// components/MapLink.js

import { PropsWithChildren } from "react";
interface Props {
  lat: number;
  lng: number;
  provider?: string;
}
const MapLink: React.FC<PropsWithChildren<Props>> = ({
  lat,
  lng,
  children,
  provider = "google",
}) => {
  const getMapUrl = () => {
    switch (provider) {
      case "apple":
        return `https://maps.apple.com/?q=${lat},${lng}`;
      case "openstreetmap":
        return `https://www.openstreetmap.org/?mlat=${lat}&mlon=${lng}#map=18/${lat}/${lng}`;
      case "google":
      default:
        return `https://www.google.com/maps?q=${lat},${lng}`;
    }
  };

  return (
    <a
      href={getMapUrl()}
      target="_blank"
      rel="noopener noreferrer"
      className="map-link text-decoration-underline"
    >
      {children}
    </a>
  );
};

export default MapLink;
